export const OPPORTUNITY_NOT_AVAILABLE_MESSAGE = 'This opportunity is not available.';

const GENERIC_AXIOS_STATUS = /^Request failed with status code \d+$/i;

/** User-facing message for site load failures (ThreeDViewer, dashboard banner). */
export function formatSiteLoadErrorMessage(
    error: unknown,
    fallback = 'An unexpected error occurred during site loading.',
): string {
    if (typeof error === 'string' && error.trim()) {
        return error.trim();
    }

    if (error instanceof Error) {
        const msg = error.message?.trim();
        if (msg && !GENERIC_AXIOS_STATUS.test(msg)) {
            return msg;
        }
    } else if (error && typeof error === 'object' && 'message' in error) {
        const msg = String((error as { message?: unknown }).message ?? '').trim();
        if (msg && !GENERIC_AXIOS_STATUS.test(msg)) {
            return msg;
        }
    }

    const ax = error as { response?: { status?: number; data?: { Message?: unknown; message?: unknown } } };
    const responseMessage = ax?.response?.data?.Message ?? ax?.response?.data?.message;
    if (typeof responseMessage === 'string' && responseMessage.trim()) {
        return responseMessage.trim();
    }

    const status = ax?.response?.status;
    if (status === 400 || status === 404) {
        return OPPORTUNITY_NOT_AVAILABLE_MESSAGE;
    }

    return fallback;
}

/** True when `/api/Opportunities/{sfid}` indicates the opportunity cannot be loaded. */
export function isOpportunityUnavailableError(error: unknown): boolean {
    const ax = error as { response?: { status?: number } };
    const status = ax?.response?.status;
    return status === 400 || status === 404;
}
